import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export const useAddSupplier = (supplierType: string) =>
  useAPIAction(
    SuppliersApi,
    async (api) => {
      const data = await api.supplierDraftCreate({
        controlcenterMelcoModelsCreateSupplier: {
          supplier_type: supplierType,
        },
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "managesuppliers.actions.add",
    }
  );
